import React from "react";

function InstockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="48"
      viewBox="0 0 60 48"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M46.172 12.506l-3.15-9.431A4.488 4.488 0 0038.756 0H9.244a4.488 4.488 0 00-4.266 3.075L.234 17.306c-.15.46-.234.938-.234 1.425V43.5C0 45.984 2.016 48 4.5 48H42c9.938 0 18-8.063 18-18 0-8.503-5.906-15.61-13.828-17.494zM25.5 3h13.256c.647 0 1.219.413 1.425 1.022l2.672 8.015c-.281-.009-.562-.046-.853-.046-5.325 0-10.097 2.325-13.387 6H25.5V3zM7.819 4.022A1.504 1.504 0 019.244 3H22.5v15H3.16L7.818 4.022zM4.5 45c-.825 0-1.5-.675-1.5-1.5V21h23.428A17.88 17.88 0 0024 30c0 6.263 3.206 11.775 8.063 15H4.5zM42 45c-8.269 0-15-6.731-15-15s6.731-15 15-15 15 6.731 15 15-6.731 15-15 15zm6.056-20.784a.741.741 0 00-1.05 0l-6.553 6.496-2.84-2.868a.741.741 0 00-1.05 0l-1.754 1.743c-.29.291-.29.76 0 1.05l5.1 5.147c.291.291.76.291 1.05 0l8.832-8.765c.29-.29.29-.76 0-1.05l-1.735-1.753z"></path>
        </g>
      </g>
    </svg>
  );
}

export default InstockIcon;
